import React, { /* useEffect, */ useState } from 'react';
import Background from 'components/common/Background';
import Flex from 'components/common/Flex';
import { Button, Card, /* Col, */ Collapse, Form /* , Row */ } from 'react-bootstrap';
import invite from 'assets/img/icons/spot-illustrations/49.png';
import { useForm } from 'react-hook-form';
import Person from 'components/modules/person/Person';
import Input from 'components/common/Input';
import MutateRouter from 'components/modules/routes/MutateRouter';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import TypeContract from './TypeContract';
import ItemsContract from './ItemsContract';
import { v4 as uuid } from 'uuid';
import IconButton from 'components/common/IconButton';
import useErrors from 'hooks/useErrors';
import { useMutation /* , useQuery */ } from '@tanstack/react-query';
import { contractService /* , settingsService */ } from 'services';
import { contractAdacter } from 'adapters';
import Charging from 'components/common/Charging';
import { contextApp } from 'context';
import { useNavigate } from 'react-router-dom';

const NewContract = () => {
 const { setError } = useErrors();
 const navigate = useNavigate();
 const [items, setItems] = useState({ title: '', text: '' });
 const [showItem, setShowItem] = useState(false);
 const [loading, setIsLoading] = useState(false);
 const { auth } = contextApp();
 const {
  watch,
  setValue,
  register,
  handleSubmit,
  formState: { errors }
 } = useForm({ defaultValues: { items: [], emitters: [auth?.company], receivers: [] } });

 const { newContract } = contractService.useApiContracts();
 //  const { getTreaty } = settingsService.useApiSettings();

 const { mutate: createContract } = useMutation(newContract);

 const onItems = ({ target: { name, value } }) => setItems({ ...items, [name]: name === 'title' ? value.toUpperCase() : value });

 const inItems = () => {
  const { title, text, ...res } = items;

  if (!title || !text) return;

  const id = res?.id || uuid();
  const arr = watch('items').map(e => e);

  const index = arr.findIndex(e => e.id == items?.id);
  arr.splice(index, index < 0 ? 0 : 1, { id, title, text });

  setValue('items', arr);
  setItems({ title: '', text: '' });
  setShowItem(false);
 };

 const itemEdit = obj => {
  setItems(obj);
  setShowItem(true);
 };

 const itemDelet = id =>
  setValue(
   'items',
   watch('items').filter(e => e.id !== id)
  );

 const onError = e => console.log(e, 'estos son los errores');

 const onSubmitData = async data => {
  setIsLoading(true);
  createContract(contractAdacter.create(data), {
   onSuccess: () => navigate('/settings/contracts'),
   onError: err => setError(err),
   onSettled: () => setIsLoading(false)
  });
 };

 if (loading) return <Charging />;

 return (
  <>
   <Card className="bg-transparent-50 overflow-hidden">
    <Card.Header className="position-relative">
     <Background
      image={invite}
      className="d-none d-md-block bg-card z-index-1"
      style={{
       backgroundSize: '230px',
       backgroundPosition: 'right bottom',
       zIndex: '-1'
      }}
     />
     <div className="position-relative z-index-2">
      <div>
       <h3 className="text-primary mb-1">Gestione su Contratacion Aqui!</h3>
       <p className="text-700">Asigne los parámetros necesarios para el contrato que desee</p>
      </div>
      <Flex className="py-3">
       <div className="pe-3">
        <p className="text-800 fs-1 fw-medium">Segun el Modelo de contrato compártale un link de acceso atraves de Inmovilii</p>
       </div>
      </Flex>
     </div>
    </Card.Header>

    <Card.Body className="px-0 px-sm-3">
     <ul className="mb-0 list-unstyled">
      <li className="alert mb-0 rounded-0 py-2 px-card alert-info border-x-0 border-top-0">
       <Person
        title={
         <>
          Contratista<code className="text-monospace fs--2 text-400">(s)</code>
         </>
        }
        sub="Enpresa o persona a quien se contrata"
        Entities={e => setValue('receivers', e)}
        limit={0}
        err={!!errors?.receivers}
        position="bottom"
        vr="info"
       />
       <Input
        type="hidden"
        formControlProps={{ ...register('receivers', { required: true, validate: value => value?.length || false }) }}
       />
      </li>
      {/* <li className="alert mb-0 rounded-0 py-2 px-card alert-warning border-x-0 border-top-0 mt-1">
       <Person
        title={
         <>
          Contratante<code className="text-monospace fs--2 text-400">(s)</code>
         </>
        }
        sub="Enpresa o persona que contrata"
        fixedEntity={auth?.company}
        Entities={e => setValue('emitters', e)}
        err={!!errors?.emitters}
        vr="warning"
       />
       <Input
        type="hidden"
        formControlProps={{ ...register('emitters', { required: true, validate: value => value?.length || false }) }}
       />
      </li> */}
      <li className="alert mb-0 rounded-0 py-2 px-card alert-primary border-x-0 border-top-0 mt-1">
       <Flex className="fs--2 px-2" alignItems="center" justifyContent="end" wrap="wrap">
        <span className="fa-stack me-2 ms-n1 circle-dashed" style={{ width: '35px', height: '35px' }}>
         <FontAwesomeIcon icon="circle" className="fa-stack-2x fs--1 text-300" />
         <FontAwesomeIcon icon="network-wired" className="fa-inverse fa-stack-1x fs-0 text-primary" ransform="shrink-3" />
        </span>
        <div className="flex-1">
         <h6 className="mb-0 text-primary">
          <span className="pe-3">Rutas y Permisos</span>
         </h6>
         <p className="mb-0">Establece las rutas y permisos para el usuario</p>
        </div>
        <MutateRouter setPaths={paths => setValue('routes', paths)} err={!!errors?.routes} />
        <Input
         type="hidden"
         formControlProps={{ ...register('routes', { required: true, validate: value => value?.routes?.length || false }) }}
        />
       </Flex>
      </li>
      <li className="alert mb-0 rounded-0 py-2 px-card alert-success border-x-0 border-top-0 mt-1">
       <Flex className="fs--2 px-2" justifyContent="end" alignItems="center" wrap="wrap">
        <span className="fa-stack me-2 ms-n1 circle-dashed" style={{ width: '35px', height: '35px' }}>
         <FontAwesomeIcon icon="circle" className="fa-stack-2x fs--1 text-300" />
         <FontAwesomeIcon icon="file-signature" className="fa-inverse fa-stack-1x fs-0 text-success" ransform="shrink-3" />
        </span>
        <div className="flex-grow-1">
         <h6 className="mb-0 text-success">
          <span className="pe-3">Tipo de Contrato</span>
         </h6>
         <p className="mb-0">Establece el tipo de contrato para el usuario</p>
        </div>
        <Input
         type="select"
         name="type"
         placeholder="Tipo contrato"
         errors={errors}
         formGroupProps={{ className: 'px-2 mt-2 mt-sm-0' }}
         formControlProps={{ ...register('type', { required: true }), size: 'sm' }}
         options={[
          { label: 'Prestación', value: 'Prestacion' },
          { label: 'Laboral', value: 'Laboral' }
         ]}
        />
       </Flex>
      </li>
      <Collapse in={/Prestacion|Laboral/.test(watch('type'))}>
       <div className="border rounded">
        <TypeContract watch={watch} register={register} setValue={setValue} errors={errors} />
       </div>
      </Collapse>
      <li className="alert mb-0 rounded-0 py-2 px-card alert-secondary border-x-0 border-top-0 mt-1">
       <Flex className="fs--2 px-2" justifyContent="end" alignItems="center" wrap="wrap">
        <span className="fa-stack me-2 ms-n1 circle-dashed" style={{ width: '35px', height: '35px' }}>
         <FontAwesomeIcon icon="circle" className="fa-stack-2x fs--1 text-300" />
         <FontAwesomeIcon icon="list" className="fa-inverse fa-stack-1x fs-0 text-secondary" ransform="shrink-3" />
        </span>
        <div className="flex-grow-1">
         <h6 className="mb-0 text-secondary">
          <span className="pe-3">Terminos</span>
         </h6>
         <p className="mb-0">Establece los terminos de contrato</p>
        </div>
        <div>
         <Button variant="falcon-secondary" className="p-0 icon-item icon-item-sm" onClick={() => setShowItem(!showItem)}>
          <FontAwesomeIcon icon={showItem ? 'chevron-up' : 'chevron-down'} />
         </Button>
         <Input
          type="hidden"
          formControlProps={{ ...register('items', { required: true, validate: value => value?.length || false }) }}
         />
        </div>
       </Flex>
       <Collapse in={showItem || !!errors?.items}>
        <div className="pt-2">
         <div className="position-relative fs--1">
          <Form.Control
           rows={1}
           type="text"
           name="text"
           as="textarea"
           autoComplete="off"
           onChange={onItems}
           value={items?.text}
           className="pt-5 pe-5 fs--1"
           placeholder="Descripción del ítem a agregar"
           isInvalid={!!errors?.items}
          />

          <Input
           type="text"
           name="title"
           placeholder="Título del ítem a agregar"
           errors={errors?.items ? { title: true } : {}}
           formGroupProps={{ className: 'd-flex position-absolute start-0 top-0 w-75' }}
           formControlProps={{
            name: 'title',
            autoComplete: 'off',
            value: items?.title,
            onChange: onItems,
            plaintext: true,
            style: { outline: 'none' },
            className: 'mx-3 mt-2 p-0 border-bottom text-uppercase'
           }}
          />

          <div className="position-absolute end-0 bottom-0 mb-2 me-2">
           <Button variant="falcon-primary" className="icon-item icon-item-sm" onClick={inItems}>
            <FontAwesomeIcon icon="plus" className="text-primary" />
           </Button>
          </div>
         </div>
        </div>
       </Collapse>
      </li>
      <Collapse in={watch('items').length > 0}>
       <div className="border rounded p-3">
        {watch('items').map(({ id, title, text }, i, arr) => (
         <ItemsContract
          key={i}
          id={id}
          title={title}
          text={text}
          isLast={i === arr.length - 1}
          itemEdit={itemEdit}
          itemDelet={itemDelet}
         />
        ))}
       </div>
      </Collapse>
     </ul>
    </Card.Body>
    <Card.Footer>
     <IconButton
      size="sm"
      icon="plus"
      transform="shrink-2"
      variant="falcon-default"
      className="m-0 fs--1 mx-2 z-index-1000 float-end"
      onClick={() => handleSubmit(onSubmitData, onError)()}
     >
      Crear contrato
     </IconButton>
    </Card.Footer>
   </Card>
  </>
 );
};

export default NewContract;
